export default __webpack_public_path__ + "static/17-ac86369404eeffcae5009313377ab28f.webp";